import React, { useEffect, useState, useRef } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { CheckCircle2Icon, XIcon } from 'lucide-react';
const buyers = [{
  name: 'Valentina G.',
  city: 'Buenos Aires'
}, {
  name: 'Lucía M.',
  city: 'Córdoba'
}, {
  name: 'Romina P.',
  city: 'Rosario'
}, {
  name: 'Camila R.',
  city: 'La Plata'
}, {
  name: 'Sofía L.',
  city: 'Mendoza'
}, {
  name: 'Martina F.',
  city: 'Mar del Plata'
}, {
  name: 'Agustina B.',
  city: 'San Miguel de Tucumán'
}, {
  name: 'Florencia D.',
  city: 'Salta'
}, {
  name: 'Julieta S.',
  city: 'Santa Fe'
}, {
  name: 'Carla V.',
  city: 'Neuquén'
}, {
  name: 'Paula T.',
  city: 'Bahía Blanca'
}, {
  name: 'Micaela A.',
  city: 'San Juan'
}, {
  name: 'Antonella C.',
  city: 'Paraná'
}, {
  name: 'Daniela O.',
  city: 'Resistencia'
}, {
  name: 'Brenda N.',
  city: 'Posadas'
}, {
  name: 'Ayelén M.',
  city: 'San Salvador de Jujuy'
}, {
  name: 'Rocío P.',
  city: 'Río Cuarto'
}, {
  name: 'Belén H.',
  city: 'Quilmes'
}];
const offers = ['Pack HYROX Imparable', 'Pack HYROX Imparable Total'];
interface Sale {
  name: string;
  city: string;
  offer: string;
  minsAgo: number;
}
function randomSale(): Sale {
  const buyer = buyers[Math.floor(Math.random() * buyers.length)];
  const offer = offers[Math.floor(Math.random() * offers.length)];
  const minsAgo = Math.floor(Math.random() * 8) + 1;
  return {
    ...buyer,
    offer,
    minsAgo
  };
}
export function PurchaseNotification() {
  const [sale, setSale] = useState<Sale | null>(null);
  const timeouts = useRef<ReturnType<typeof setTimeout>[]>([]);
  useEffect(() => {
    let active = true;
    const clearAll = () => {
      timeouts.current.forEach(clearTimeout);
      timeouts.current = [];
    };
    const showNext = () => {
      if (!active) return;
      setSale(randomSale());
      // visible for ~5s
      timeouts.current.push(setTimeout(() => {
        if (!active) return;
        setSale(null);
        // wait 20–30s before the next one
        const wait = 20000 + Math.random() * 10000;
        timeouts.current.push(setTimeout(showNext, wait));
      }, 5000));
    };
    // first popup after a short initial delay
    timeouts.current.push(setTimeout(showNext, 6000));
    return () => {
      active = false;
      clearAll();
    };
  }, []);
  return <AnimatePresence data-id="element-229">
      {sale && <motion.div key={`${sale.name}-${sale.offer}`} initial={{
      opacity: 0,
      x: -40,
      y: 10
    }} animate={{
      opacity: 1,
      x: 0,
      y: 0
    }} exit={{
      opacity: 0,
      x: -40
    }} transition={{
      type: 'spring',
      stiffness: 260,
      damping: 24
    }} className="fixed left-4 bottom-24 md:bottom-6 z-[60] max-w-[320px] w-[calc(100%-2rem)] sm:w-auto" role="status" aria-live="polite" data-id="element-230">
          <div className="flex items-center gap-3 bg-brand-dark border border-brand-pink/30 rounded-xl p-3 pr-9 shadow-[0_10px_40px_rgba(0,0,0,0.6)] relative" data-id="element-231">
            <button onClick={() => setSale(null)} aria-label="Cerrar notificación" className="absolute top-2 right-2 text-gray-500 hover:text-white transition-colors" data-id="element-232">
              <XIcon className="w-3.5 h-3.5" data-id="element-233" />
            </button>

            <div className="flex-shrink-0 w-10 h-10 rounded-full bg-brand-pink/10 border border-brand-pink/30 flex items-center justify-center" data-id="element-234">
              <CheckCircle2Icon className="w-5 h-5 text-brand-pink" data-id="element-235" />
            </div>

            <div className="min-w-0" data-id="element-236">
              <div className="flex items-center gap-1.5 mb-0.5" data-id="element-237">
                <span className="text-white font-semibold text-sm truncate" data-id="element-238">
                  {sale.name}
                </span>
                <span className="text-[10px] text-gray-500" data-id="element-239">·</span>
                <span className="text-gray-400 text-xs truncate" data-id="element-240">
                  {sale.city}
                </span>
              </div>
              <p className="text-gray-300 text-xs leading-tight" data-id="element-241">
                Compró el{' '}
                <span className="text-brand-pink font-semibold" data-id="element-242">
                  {sale.offer}
                </span>
              </p>
              <div className="flex items-center gap-1 mt-1" data-id="element-243">
                <span className="w-1.5 h-1.5 rounded-full bg-green-400" data-id="element-244" />
                <span className="text-[10px] text-gray-500 uppercase tracking-wide" data-id="element-245">
                  Compra verificada · hace {sale.minsAgo} min
                </span>
              </div>
            </div>
          </div>
        </motion.div>}
    </AnimatePresence>;
}